import React, {memo, useState} from "react";
import {useTranslation} from "react-i18next";
//local
import SubHeading from "components/SubHeading";
import {hasPermission} from "helpers/helper";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {MonitorSuppliersFilterModal} from "../components/MonitorSuppliersFilterModal";
import {IconCog, IconBinoculars} from "components/icons";

const MonitorSuppliersSettings = memo(
  ({settings, organization, isAdminOwner, onUpdate}) => {
    const {t} = useTranslation();

    const [isMonitorSuppliersFilterModal, setMonitorSuppliersFilterModal] =
      useState(false);
    const isMonitoringSuppliersEnabled = organization?.allowMonitorSuppliers;

    return (
      <>
        {hasPermission(["ENABLE_MONITOR_SUPPLIERS"]) && (
          <div className="mb-12">
            <div className="df">
              <SubHeading
                title="SETTINGS_ORGANIZATION_MONITOR_SUPPLIERS"
                icon={<IconBinoculars height="20" width="21" />}
              />
            </div>
            <div className="df-row-center mt-4">
              {isMonitoringSuppliersEnabled
                ? t("SETTINGS_ORGANIZATION_MONITOR_SUPPLIERS_STAT")?.format(
                    settings.monitorSuppliersCompaniesCount ?? 0,
                    settings.monitorSuppliersUsersCount ?? 0
                  )
                : t("SETTINGS_ORGANIZATION_MONITOR_SUPPLIERS_DESCRIPTION")}
            </div>
            {isMonitoringSuppliersEnabled ? (
              <ButtonTransparent
                name="SETTINGS_ORGANIZATION_MONITOR_SUPPLIERS_SETTINGS_BUTTON"
                icon={<IconCog />}
                noBorder
                small
                addClass="fz-14 pl-0 __rotate-on-hover mt-3"
                onClick={() => setMonitorSuppliersFilterModal(true)}
              />
            ) : (
              <a
                className="link df mt-4"
                href={t("URL_TO_PUBLIC_CONTACT_PAGE")}
                target="_new"
              >
                {t("SETTINGS_ORGANIZATION_MONITOR_SUPPLIERS_LINK")}
              </a>
            )}
          </div>
        )}
        {isMonitorSuppliersFilterModal && (
          <MonitorSuppliersFilterModal
            initialFilters={settings.monitorSuppliersFilter}
            isAdminOwner={isAdminOwner}
            onChange={(monitorSuppliersFilter) => onUpdate({monitorSuppliersFilter})}
            onClose={() => setMonitorSuppliersFilterModal(false)}
          />
        )}
      </>
    );
  }
);

export default MonitorSuppliersSettings;
